import type {InjectionKey, Ref} from 'vue';
import type {PrismicDocument} from '@prismicio/types';
import type {PrismicClient} from '#imports';

export const PRISMIC_CLIENT: InjectionKey<PrismicClient> = Symbol('Prismic Client');
export const PRISMIC_DOCUMENT: InjectionKey<Ref<PrismicDocument | undefined>> = Symbol('Prismic Document');
